"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewDateType = exports.getSurveyDateFormat = exports.getDateFormat = exports.default = exports.convertValueToSet = exports.convertValueToDisplay = exports.convertMinMaxToMoment = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _constants = _interopRequireDefault(require("../../../constants"));
var _constants2 = require("../constants");
var _dateTimeInlinePicker = _interopRequireDefault(require("../../../dateTimeInlinePicker"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _Constants$DateTimeFo = _constants.default.DateTimeFormat,
  shortDate = _Constants$DateTimeFo.shortDate,
  shortTimeAMPM = _Constants$DateTimeFo.shortTimeAMPM,
  dateTimeAMPM = _Constants$DateTimeFo.dateTimeAMPM,
  shortTime = _Constants$DateTimeFo.shortTime,
  defaultSurveyDate = _Constants$DateTimeFo.defaultSurveyDate,
  defaultSurveyDateTime = _Constants$DateTimeFo.defaultSurveyDateTime;
var DATE_PLACEHOLDER = {
  dateCustom: 'MM/DD/YYYY',
  timeCustom: 'HH:MM AM/PM',
  dateTimeCustom: 'MM/DD/YYYY HH:MM AM/PM'
};
var getViewDateType = function getViewDateType(internalType) {
  var viewMode;
  switch (internalType) {
    case _constants2.DATE_TYPE.TIME:
      viewMode = _constants2.DATE_TIME_VIEW_MODE.TIME;
      break;
    case _constants2.DATE_TYPE.DATE_TIME:
      viewMode = _constants2.DATE_TIME_VIEW_MODE.DATE_TIME;
      break;
    default:
      viewMode = _constants2.DATE_TIME_VIEW_MODE.DATE;
  }
  return viewMode;
};
exports.getViewDateType = getViewDateType;
var getDateFormat = function getDateFormat(question) {
  var dateFormat;
  switch (question.internalType) {
    case _constants2.DATE_TYPE.TIME:
      dateFormat = shortTimeAMPM;
      break;
    case _constants2.DATE_TYPE.DATE_TIME:
      dateFormat = dateTimeAMPM;
      break;
    default:
      dateFormat = shortDate;
  }
  return dateFormat;
};
exports.getDateFormat = getDateFormat;
var getSurveyDateFormat = function getSurveyDateFormat(question) {
  var dateFormat;
  switch (question.internalType) {
    case _constants2.DATE_TYPE.TIME:
      dateFormat = shortTime;
      break;
    case _constants2.DATE_TYPE.DATE_TIME:
      dateFormat = defaultSurveyDateTime;
      break;
    default:
      dateFormat = defaultSurveyDate;
  }
  return dateFormat;
};
exports.getSurveyDateFormat = getSurveyDateFormat;
var convertMinMaxToMoment = function convertMinMaxToMoment(value, dateFormat, type) {
  if (value) {
    if (type === _constants2.DATE_TYPE.TIME) {
      // value of Time question is using format 'hh:mm' when set to survey or save into DB
      // to support validate min, max
      // but it using format 'hh:mm A' on excel file or on UI
      return (0, _momentTimezone.default)(value, shortTime, true);
    }
    return (0, _momentTimezone.default)(value, dateFormat, true);
  }
  return value;
};
exports.convertMinMaxToMoment = convertMinMaxToMoment;
var convertValueToDisplay = function convertValueToDisplay(value, dateFormat, type) {
  if (value) {
    var momentDate;
    switch (type) {
      case _constants2.DATE_TYPE.TIME:
        momentDate = (0, _momentTimezone.default)(value, shortTime, true);
        break;
      case _constants2.DATE_TYPE.DATE_TIME:
        momentDate = (0, _momentTimezone.default)(value, defaultSurveyDateTime, true);
        break;
      default:
        momentDate = (0, _momentTimezone.default)(value, defaultSurveyDate, true);
    }
    return momentDate.format(dateFormat);
  }
  return value;
};
exports.convertValueToDisplay = convertValueToDisplay;
var convertValueToSet = function convertValueToSet(value, dateFormat, type) {
  if (value) {
    var momentDate = (0, _momentTimezone.default)(value, dateFormat, true);
    switch (type) {
      case _constants2.DATE_TYPE.TIME:
        return momentDate.format(shortTime);
      case _constants2.DATE_TYPE.DATE_TIME:
        return momentDate.format(defaultSurveyDateTime);
      default:
        return momentDate.format(defaultSurveyDate);
    }
  }
  return value;
};
exports.convertValueToSet = convertValueToSet;
var CustomQuestionDateTime = function CustomQuestionDateTime(props) {
  var question = props.question;
  var isDesignMode = question.isDesignMode,
    isReadOnly = question.isReadOnly;
  var dateFormat = getDateFormat(question);
  var dateTimeRef = _react.default.useRef(null);
  var _useState = (0, _react.useState)(convertValueToDisplay(question.value, dateFormat, question.internalType)),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dateValue = _useState2[0],
    setDateValue = _useState2[1];
  var minDateTime = '';
  var maxDateTime = '';
  if (question.min && question.min !== '') {
    minDateTime = convertMinMaxToMoment(question.min, dateFormat, question.internalType);
  }
  if (question.max && question.max !== '') {
    maxDateTime = convertMinMaxToMoment(question.max, dateFormat, question.internalType);
  }
  (0, _react.useEffect)(function () {
    if (question.value) {
      // value of Time question is using format 'hh:mm' when set to survey or save into DB
      // to support validate min, max
      // but it using format 'hh:mm A' on excel file or on UI
      // need convert time twice to make sure valid on both UI and Survey
      var newValue = convertValueToSet(convertValueToDisplay(question.value, dateFormat, question.internalType), dateFormat, question.internalType);
      if (newValue !== question.value) {
        question.value = newValue;
      }
    }
  });
  var onUpdateValue = function onUpdateValue(newValue) {
    var valueToSet = convertValueToSet(newValue, dateFormat, question.internalType);
    // Set value for question
    question.value = valueToSet;
    // Set value for survey data to synchronize with question value
    var internalSurvey = question.survey;
    var surveyData = _lodash.default.cloneDeep(internalSurvey.data);
    surveyData[question.name] = valueToSet;
    internalSurvey.data = surveyData;
    if (typeof newValue === 'string') {
      // Input value type string (10:00 a | 10:00 am)
      // need to be converted to correct display format (10:00 AM) before validation
      var displayValue = question.value !== _constants2.INVALID_DATE ? convertValueToDisplay(question.value, dateFormat, question.internalType) : newValue;
      setDateValue(displayValue);
      question.customValue = displayValue;
    } else {
      setDateValue(convertValueToDisplay(question.value, dateFormat, question.internalType));
      question.customValue = convertValueToDisplay(question.value, dateFormat, question.internalType);
      question.hasErrors(true);
    }
  };
  var backToDefaultValue = function backToDefaultValue() {
    question.setDefaultValue();
    setDateValue(convertValueToDisplay(question.value, dateFormat, question.internalType));
  };
  (0, _react.useEffect)(function () {
    // Back to default value when is read-only status change
    if (question.isReadOnly) {
      backToDefaultValue();
    }
  }, [question.isReadOnly]);
  (0, _react.useEffect)(function () {
    // Need to correct value from default expression when component mount
    backToDefaultValue();
    return function () {
      // Back to default value when component unmount
      backToDefaultValue();
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "datetime-picker-field ".concat(question.errors.length ? 'error-field' : '')
  }, /*#__PURE__*/_react.default.createElement(_dateTimeInlinePicker.default, {
    value: dateValue,
    className: "date-custom",
    disabled: isDesignMode || isReadOnly,
    onChange: function onChange(e) {
      onUpdateValue(e);
    },
    viewMode: getViewDateType(question.internalType),
    name: question.name,
    ref: dateTimeRef,
    maxDate: maxDateTime,
    minDate: minDateTime,
    clearable: true,
    readOnly: false,
    dateFormat: shortDate,
    dateTimeFormat: dateTimeAMPM,
    placeholderText: DATE_PLACEHOLDER[question.internalType]
  }));
};
CustomQuestionDateTime.propTypes = {
  question: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    isDesignMode: _propTypes.default.bool.isRequired,
    errors: _propTypes.default.instanceOf(Array).isRequired,
    value: _propTypes.default.shape({}).isRequired,
    customValue: _propTypes.default.shape({}).isRequired,
    title: _propTypes.default.string.isRequired,
    requiredErrorText: _propTypes.default.string.isRequired,
    defaultValue: _propTypes.default.string.isRequired,
    isRequired: _propTypes.default.bool.isRequired,
    isReadOnly: _propTypes.default.bool.isRequired,
    min: _propTypes.default.string,
    max: _propTypes.default.string,
    internalType: _propTypes.default.string,
    hasErrors: _propTypes.default.func.isRequired,
    defaultValueExpression: _propTypes.default.string,
    setDefaultValue: _propTypes.default.func.isRequired,
    survey: _propTypes.default.shape({
      data: _propTypes.default.shape({})
    }).isRequired
  }).isRequired
};
CustomQuestionDateTime.defaultProps = {};
var _default = CustomQuestionDateTime;
exports.default = _default;